import './App.css';
import React from 'react';
import MinimumWage from './minimumwage';

const App = () => {
  return (
    <div>
      <h1>Your React App</h1>
      <MinimumWage />
    </div>
  );
};

export default App;

